import { useNow } from "../../hooks/useNow";
import { formatHHMM } from "../../lib/time";
import { Icon } from "../Icon";
import { usePendingWrites } from "../../hooks/usePendingWrites";

export function DesktopTopBar({ onLock }: { onLock: () => void }) {
  const now = useNow(5_000);
  return (
    <header className="sticky top-0 z-30">
      <div className="absolute inset-0 bg-ink-950/80 backdrop-blur-xl pointer-events-none" />
      <div
        className="absolute inset-x-0 bottom-0 h-px pointer-events-none"
        style={{
          background:
            "linear-gradient(to right, transparent, rgba(255,255,255,0.08) 15%, rgba(255,255,255,0.08) 85%, transparent)",
        }}
      />
      <div className="relative px-6 py-3 flex items-center gap-6">
        <div className="flex items-center gap-3">
          <span className="w-1 h-5 bg-accent rounded-full" />
          <div className="text-accent text-2xs font-semibold tracking-eyebrow">
            NEXXT
          </div>
          <div className="w-px h-4 bg-white/[0.08]" />
          <div className="text-zinc-100 font-semibold tracking-tight">
            Pal Mundo · CP
          </div>
          <div className="hidden sm:block text-zinc-500 text-2xs tracking-eyebrow uppercase">
            Pal Mundo · 18 jul 2026
          </div>
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-2">
          <div
            className="text-3xl font-semibold tabular leading-none tracking-tight"
            style={{ fontFeatureSettings: '"ss01", "cv11"' }}
          >
            {formatHHMM(now)}
          </div>
          <DesktopSyncDot />
        </div>
        <button
          onClick={onLock}
          aria-label="Vergrendel"
          className="ml-2 w-10 h-10 rounded-full bg-ink-850 hover:bg-ink-800 text-zinc-400 hover:text-zinc-200 flex items-center justify-center"
          style={{
            border: "1px solid rgba(255,255,255,0.06)",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,0.04)",
          }}
        >
          <Icon.Lock />
        </button>
      </div>
    </header>
  );
}

function DesktopSyncDot() {
  const pending = usePendingWrites();
  if (!pending) return null;
  return (
    <span
      role="status"
      aria-label="Schrijfacties synchroniseren"
      title="Schrijfacties synchroniseren"
      className="w-2 h-2 rounded-full bg-accent animate-pulseSoft"
    />
  );
}
